import React from 'react';
import CalendarPage from './CalendarPage';

// Legacy wrapper for backward compatibility
const AcademicCalendarModule = ({ onBack }) => {
  return <CalendarPage onBack={onBack} />;
};

export default AcademicCalendarModule;
